import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { File } from '@ionic-native/file';
import { FileTransfer } from '@ionic-native/file-transfer';
import { Storage } from "@ionic/storage";
import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs';
import { AttendanceGetButton } from '../../../../model/attendance/attendance-get-button';
import { Paginate } from '../../../../model/paginate';
import { StoragePathProvider } from '../../../../providers/storage-path/storage-path';
import { LoopBackConfig } from '../../../sdk/lb.config';
import { FormDataUpload, NestApiProvider } from '../../nest-api';
import { NestAuthProvider } from '../../nest-auth';
import { RequestRecordTimeGdDto, RequestRecordTimeSF6Dto, ResponseGetUserAttendanceWeekDto, ResponseRecordTimeDto, ResponseRecordTimeSF6Dto, RequestRecordTimeBarcodeSF6Dto, RequestRecordTimeBarcodeGdDto, RequestMyAttendanceData, ObjectData, ResponseFaceDetectionDto } from '../dto/attendance.dto';
import { ResponseData } from '../../nest-responses';

/*
  Generated class for the AttendanceApi provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

// INTERFACE

@Injectable()
export class AttendanceApi {

  private module: string = 'attendance';
  private headerOptionsJson: any;
  private timeout: number = 60000;
  private urlAWS = 'https://packagewhitelists.dataon.com/logs';

  constructor(
    public http: HttpClient,
    public storage: Storage,
    public platform: Platform,
    public nestAuth: NestAuthProvider,
    public transfer: FileTransfer,
    public file: File,
    public storagePathProvider: StoragePathProvider,
    public nestApi: NestApiProvider,
  ) {

  }

  getUrlUploadAttendanceFile(isEmp) {
    let url = '';
    const companyCode = this.nestApi.SFGoAuth.companyCode;

    if (isEmp) {
      url = LoopBackConfig.getPath() + "/api/StorageAttendanceMachines/" + companyCode + "/uploadEmpNo";
    } else {
      url = this.nestApi.attendanceHost + '/attendances/uploadAttendanceFile';
    }

    return url;
  }

  uploadAttendanceFile(file) {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "uploadAttendanceFile";
    const params: FormDataUpload[] = [];
    params.push({ name: 'file', value: file });
    const urlParams: any = {};

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.requestUpload(method, url, params);
  }

  uploadAttendanceEmpNo(file) {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "employeeNoMachine";
    const params: FormDataUpload[] = [];
    params.push({ name: 'file', value: file });
    const urlParams: any = {};

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.requestUpload(method, url, params);
  }

  recordTime(formData: RequestRecordTimeGdDto): Observable<ResponseRecordTimeDto> {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "recordTime";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseRecordTimeDto>(method, url, params, urlParams, body, contentType, this.timeout);
  }

  recordTimeQRCodeGD(formData: RequestRecordTimeBarcodeGdDto): Observable<ResponseRecordTimeDto> {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "qrCodeAttendance";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseRecordTimeDto>(method, url, params, urlParams, body, contentType, this.timeout);
  }

  getButtonAttendance(datetime) {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "getButtonAttendance";
    const params: any = { times: datetime };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<AttendanceGetButton>(method, url, params, urlParams, body, contentType);
  }

  getUserAttendanceList() {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "getUserAttendanceList";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  getUserAttendanceWeek(empId) {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "getUserAttendanceWeek";
    const params: any = { empId: empId };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseGetUserAttendanceWeekDto>(method, url, params, urlParams, body, contentType);
  }

  getSubordinateAttendanceList(page: number = 1, limit: number = 20) {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "getSubordinateAttendanceList";
    const params: any = {};
    const urlParams: any = { page: page, limit: limit };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType, 120000, null, true);
  }

  getTodayAttendance(empId: string, datetime: any) {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "getTodayAttendance";
    const params: any = { empId: empId, date: datetime };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType, null, null, true);
  }


  getTodayShift(empId: string, datetime: any) {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "getTodayShift";
    const params: any = { empId: empId, date: datetime };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  faceDetection(fileName) {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "faceDetection";
    const params: any = { filename: fileName };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseData<ResponseFaceDetectionDto>>(method, url, params, urlParams, body, contentType, this.timeout);
  }

  getCurrentTime() {
    return this.http.get(this.nestApi.attendanceHost + '/currentTime', { headers: this.headerOptionsJson })
  }

  getAttendanceListWithFilters(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "getUserAttendanceListWithFilters";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<any>(method, url, params, urlParams, body, contentType);
  }

  apiSendAttAWS() {
    const model: string = "attendanceLog";
    const func: string = "";
    const url: string = `${this.urlAWS}/${model}/${func}?access_token=AWS158592445055201851847989029065`;
    return url;
  }

  uploadAttAWS(body): Observable<any> {
    const model: string = "attendanceLog";
    const func: string = "uploadAttendanceLog";
    const url: string = `${this.urlAWS}/${model}/${func}?access_token=AWS158592445055201851847989029065`;
    return this.http.post(url, body);
  }

  checkLocation(data: { empId: any, lat: any, lng: any }): Observable<any> {
    const method: string = "POST";
    const model: string = "ttademplocation";
    const func: string = "checkLocation";
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  /*************************************************** API INTEGREATED SUNFISH 6 ********************************************************************/

  recordTimeSF6(formData: RequestRecordTimeSF6Dto): Observable<ResponseRecordTimeSF6Dto> {
    const method: string = "POST";
    const model: string = "attendanceSf6";
    const func: string = "AddToTemp";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseRecordTimeSF6Dto>(method, url, params, urlParams, body, contentType, this.timeout);
  }

  recordTimeQRCodeSF6(formData: RequestRecordTimeBarcodeSF6Dto): Observable<ResponseRecordTimeSF6Dto> {
    const method: string = "POST";
    const model: string = "attendanceSf6";
    const func: string = "SendQRCode";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseRecordTimeSF6Dto>(method, url, params, urlParams, body, contentType, this.timeout);
  }

  getTodayAttendanceSF6(empId: string, datetime: any) {
    const method: string = "POST";
    const model: string = "attendanceSf6";
    const func: string = "getTodayAttendance";
    const params: any = { empId: empId, date: datetime };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType, null, null, true);
  }

  getTodayShiftSF6(empId: string, datetime: any) {
    const method: string = "POST";
    const model: string = "attendanceSf6";
    const func: string = "getTodayShift";
    const params: any = { empId: empId, date: datetime };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  addBreakToTemp(formData: RequestRecordTimeSF6Dto): Observable<ResponseRecordTimeSF6Dto> {
    const method: string = "POST";
    const model: string = "attendanceSf6";
    const func: string = "AddBreakToTemp";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseRecordTimeSF6Dto>(method, url, params, urlParams, body, contentType, this.timeout);
  }

  getBreakButton(): Observable<ResponseData<any>> {
    const method: string = "GET";
    const model: string = "attendanceSf6";
    const func: string = "getBreakButton";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseData<any>>(method, url, params, urlParams, body, contentType, this.timeout);
  }

  public myAttendanceData(payload: RequestMyAttendanceData): Observable<ResponseData<ObjectData[][]>> {
    const method: string = 'GET';
    const model: string = "attendances";
    const func: string = 'myAttendanceData';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseData<any>>(method, url, params, urlParams, body, contentType, this.timeout);
  }

  checkAuthWifi(payload: { ssid: string, bssid: string }): Observable<ResponseData<any>> {
    const method: string = "GET";
    const model: string = "attendanceSf6";
    const func: string = "checkAuthWifi";
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseData<any>>(method, url, params, urlParams, body, contentType, this.timeout);
  }

  getUserAttendanceWeekNew(payload: { empId: string, startDate: string, endDate: string }): Observable<any> {
    const method: string = "POST";
    const model: string = "attendances";
    const func: string = "getUserAttendanceWeekNew";
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<any>(method, url, params, urlParams, body, contentType, this.timeout);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/attendance.api.ts